import hamburgerSvg from "../Pictures/menu_white_24dp.svg";
import closesvg from "../Pictures/close_white_24dp.svg";
import React from "react";

function HamburgerMenu({ phoneMenu, setPhoneMenu }) {
  return (
    <div
      className={`Hamburger ${phoneMenu && "Hamburger-open"}`}
      onClick={() => setPhoneMenu(!phoneMenu)}
    >
      {phoneMenu ? (
        <img src={closesvg} alt="" />
      ) : (
        <img src={hamburgerSvg} alt="" />
      )}
    </div>
  );
}

export default HamburgerMenu;
